'use strict';

var toastr = require('toastr');
var UserSecureInterceptorFactory = function UserSecureInterceptorFactory($q, $log, $injector) {
  return {
    responseError: function responseError(responseRejection) {
      try {
        if (responseRejection.status === 401) {
          var $state = $injector.get('$state');
          $state.go('app.user-landing');
        }
      } catch (e) {
        toastr.error('UserSecureInterceptorFactory: responseRejection - An error has occurred');
      }
      return $q.reject(responseRejection);
    }
  };
};
UserSecureInterceptorFactory.$inject = ['$q', '$injector', '$log'];
module.exports = UserSecureInterceptorFactory;